import { ModuleWithProviders, NgModule } from '@angular/core';

import { NbIconModule, NbOverlayModule } from '@nebular/theme';

import { TRootToastConfig, TOASTR_CONFIG } from './core/classes';
import { ToastContainerRegistry } from './core/services/toast-container-registry.service';
import { ToastService } from './core/services/toast.service';
import { ToastContainerComponent } from './toast-container/toast-container.component';

@NgModule({
  imports: [NbOverlayModule, NbIconModule, ToastContainerComponent],
})
export class ToastModule {
  static forRoot(toastrConfig: Partial<TRootToastConfig> = {}): ModuleWithProviders<ToastModule> {
    return {
      ngModule: ToastModule,
      providers: [ToastService, ToastContainerRegistry, { provide: TOASTR_CONFIG, useValue: toastrConfig }],
    };
  }
}

export const provideToast = (config: Partial<TRootToastConfig> = {}) => {
  return ToastModule.forRoot(config);
};
